import {useEffect, useRef, useState} from "react";
import {KatBox, KatButton, KatInput, KatModal} from "@amzn/katal-react";
import * as React from "react";
import {EventEmitter} from "events";
import reviewDecisionStore from "src/app/store/ReviewDecisionStore";
import {StringUtil} from "src/app/util/StringUtil";

interface ReOpenInputDialogProps {
    openDialogEvent: string;
    closeDialogEvent: string;
    eventBus: EventEmitter;
}

const ReOpenInputDialog = (props: ReOpenInputDialogProps) => {
    const [isOpen, setIsOpen] = useState(false);
    const {eventBus} = props;

    const ticketIdRef = useRef<any>(null);

    useEffect(() => {
        const handleOpenDialog = (isOpen: any) => {
            if (isOpen) {
                setIsOpen(true);
            }
        }

        eventBus.on(props.openDialogEvent, handleOpenDialog);
        return () => {
            eventBus.removeListener(props.openDialogEvent, handleOpenDialog);
        };
    }, []);

    const onConfirmationCancel = () => {
        setIsOpen(false);
    }

    const onConfirmationSubmit = async () => {
        const ticket = ticketIdRef.current.value;
        if (StringUtil.isNullOrEmpty(ticket)) {
            alert("please input Ticket id link!");
            return;
        } else {
            const newValue = {
                ...reviewDecisionStore.value,
                appealTicket: ticketIdRef.current.value
            }
            reviewDecisionStore.updateValue(newValue);
            setIsOpen(false);
            eventBus.emit(props.closeDialogEvent, true);
        }
    }

    return (
        <KatModal visible={isOpen} data-testid='kat-modal' onClose={onConfirmationCancel}>
            <span slot="title">Confirmation</span>
            <KatBox>
                <KatInput label='Ticket Id' className='ticket-input' ref={ticketIdRef} data-testid='ticket-id-input'
                          required={true}
                ></KatInput>
            </KatBox>
            <div slot="footer" className="kat-group-horizontal">
                <KatButton variant={"secondary"} label={"Cancel"}
                           onClick={onConfirmationCancel} data-testid='cancel-btn'></KatButton>
                <KatButton label={"Submit"} onClick={onConfirmationSubmit} data-testid='submit-btn'></KatButton>
            </div>
        </KatModal>
    );
};

export default ReOpenInputDialog;